const corp = () => import('@/views/main/system/corp/Corp.vue')
export default {
  path: '/main/system/corp',
  name: 'system-corp',
  component: corp,
  children: []
}
